// src/analytics/AnalyticsListener.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview, trackEvent } from './ga';

export default function AnalyticsListener() {
  const location = useLocation();

  // Page views à chaque changement de route
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  // Délégation de clics (mailto/tel/téléchargements/liens externes)
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest('a');
      if (!a) return;

      const href = a.getAttribute('href') || '';
      const downloadAttr = a.getAttribute('download');

      // mailto:
      if (href.startsWith('mailto:')) {
        trackEvent({ action: 'contact_email', category: 'contact', label: href });
        return;
      }

      // tel:
      if (href.startsWith('tel:')) {
        trackEvent({ action: 'contact_phone', category: 'contact', label: href });
        return;
      }

      // téléchargement (zip/jpg/pdf) ou attribut download
      if (downloadAttr || /\.(zip|pdf|jpg|jpeg|png)$/i.test(href)) {
        trackEvent({ action: 'download', category: 'file', label: href });
        return;
      }

      // lien externe (ex: pCloud, Instagram, etc.)
      try {
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) {
          trackEvent({ action: 'outbound_click', category: 'outbound', label: url.href });
        }
      } catch {
        /* ignore */
      }
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}